module.exports = __webpack_public_path__ + "static/img/baijiu.68d48a4b.png";